export default __webpack_public_path__ + "static/Lilly1-d30c5fd6ae8726be1a2495558f26e9f4.jpg";